import { Masterclass } from "api/resources/masterclasses/types"
import { add } from "date-fns"

import { MOCK_UPCOMING_MASTERCLASS } from "./data"

export function parseDuration(durationString: string): number {
  const parts = durationString.split(" ")

  const days = parts.length === 2 ? parseInt(parts[0]) : 0
  const timeStr = parts.length === 2 ? parts[1] : parts[0]

  const [hours, minutes, seconds] = timeStr.split(":").map(Number)

  if (Number.isNaN(hours) || Number.isNaN(minutes) || Number.isNaN(seconds)) {
    throw new Error(
      "Invalid duration string format. It should be 'd hh:mm:ss' or 'hh:mm:ss'."
    )
  }

  const totalSeconds =
    days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60 + seconds

  return totalSeconds
}

export const getMasterclassStatus = (masterclass?: Masterclass | null) => {
  if (!masterclass) return null

  const startTime = new Date(masterclass.startTime)
  const currentTime = new Date()
  const endTime = add(startTime, {
    seconds: parseDuration(masterclass.duration),
  })

  if (startTime > currentTime) {
    return "upcoming"
  }
  if (currentTime > endTime) {
    return "completed"
  }

  return "ongoing"
}

export function getUpcomingMasterclassData({
  masterclass,
}: {
  masterclass?: Masterclass | null
}): Masterclass | null {
  if (masterclass && masterclass.isRegistered === false) {
    return masterclass
  }

  return MOCK_UPCOMING_MASTERCLASS
}
